// since we don't have a 'real' category tree obj, we'll have to leverage crumbs :(
// note: this may contain different category verbiage than real life (UWP = Folding vs classic RT = Folding Tonneau Covers)

export function getCategoryTreeFromCrumbs(crumbs) {
    if (!crumbs || crumbs.length < 2) return // should at least have home & pline node

    const names = []
    const slugs = []
    // skip home & last node (pline)
    for (let i = 1; i < crumbs.length - 1; i++) {
        names.push(crumbs[i].title)
        slugs.push(crumbs[i].urlData.params[`lvl${i - 1}`])
    }

    return {
        names,
        slugs,
    }
}
